module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0025.jpg?v=13b9062f";